export default "__VITE_ASSET__BAvNv_Kv__"